module.exports = __webpack_public_path__ + "static/media/medical_cert_slider_phone1.9ee303dc.png";